import React from "react";
import { BarsChart, StatusDonut } from "../../apps/ClassroomApp/components/ClassroomCharts.jsx";

/* Each CRM report's charts -- the house chart.js panels (ClassroomCharts:
   BarsChart, StatusDonut) in the house grid (.br-charts). Every series
   arrives worked out in the summary's `charts` (crmreport.service.js
   chartsOf); this only draws it.

   The doughnut is STATE (the attendance bands), so it takes the literal
   status colours -- the pill inks, the same tones as the cards and the
   list's pills. The bars are one measure each and keep the palette's
   series colour, per the charts rule in ClassroomCharts. */

const TONE_COLOR = { good: "#0E7C6B", live: "#3A57C9", warn: "#B9700C", bad: "#B3202E" };

const CrmCharts = ({ kind, charts, total }) => {
  if (!charts) return null;

  if (kind === "students") {
    return (
      <div className="br-charts">
        <StatusDonut
          className="br-chart--side"
          title="Attendance bands"
          sub="Enrolments in the batches shown, by attendance."
          segments={(charts.bands || []).map((b) => ({ label: b.label, value: b.value, color: TONE_COLOR[b.tone] }))}
          centreValue={total}
          centreLabel="enrolments"
          empty="No batch held a session in this period."
        />
        <BarsChart
          className="br-chart--main"
          title="Attendance spread"
          sub="How many enrolments sit at each 10% of attendance."
          bars={charts.spread || []}
          empty="No batch held a session in this period."
        />
      </div>
    );
  }

  return (
    <div className="br-charts">
      <BarsChart
        className="br-chart--half"
        title="Best attendance"
        sub="Batches with 5 or more sessions."
        bars={charts.topAttendance || []}
        unit="%"
        max={100}
        horizontal
        empty="No batch has 5 sessions yet."
      />
      <BarsChart
        className="br-chart--half"
        title="Best feedback"
        sub="Average session rating, from 5 or more responses."
        bars={charts.topFeedback || []}
        unit=" ★"
        max={5}
        horizontal
        empty="No batch has 5 feedback responses yet."
      />
    </div>
  );
};

export default CrmCharts;
